import { render, staticRenderFns } from "./AccountsHeader.vue?vue&type=template&id=bb72a9ec"
import script from "./AccountsHeader.vue?vue&type=script&lang=js"
export * from "./AccountsHeader.vue?vue&type=script&lang=js"
import style0 from "./AccountsHeader.vue?vue&type=style&index=0&id=bb72a9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports